export default {
	RECRUITING: {
		title: 'Recruiting',
		content: 'The study is currently recruiting participants.',
	},
	NOT_YET_RECRUITING: {
		title: 'Not yet recruiting',
		content: 'The study has not started recruiting participants.',
	},
	ENROLLING_BY_INVITATION: {
		title: 'Enrolling by invitation',
		content:
			'The study is selecting its participants from a population, or group of people, decided on by the researchers in advance. These studies are not open to everyone who meets the eligibility criteria but only to people in that particular population, who are specifically invited to participate.',
	},
	ACTIVE_NOT_RECRUITING: {
		title: 'Active, not recruiting',
		content:
			'The study is ongoing, and participants are receiving an intervention or being examined, but potential participants are not currently being recruited or enrolled.',
	},
	COMPLETED: {
		title: 'Completed',
		content:
			'The study has concluded normally; participants are no longer receiving an intervention or being examined',
	},
	SUSPENDED: {
		title: 'Suspended',
		content: 'The study halted prematurely but potentially will resume',
	},
	TERMINATED: {
		title: 'Terminated',
		content:
			'The study halted prematurely and will not resume; participants are no longer being examined or receiving intervention.',
	},
	WITHDRAWN: {
		title: 'Withdrawn',
		content:
			'The study halted prematurely, prior to enrollment of first participant.',
	},
} as const;
